import React from 'react';

import { IVariation } from '../../../types/contentful';

import { usePageDataContext } from '../../context/PageData';

import { VariationContainer } from '../VariationContainer';
import { WebBanner } from '../WebBanner/index';

interface BannerProps {
  toggleBanner: Function;
}

export function Banners({ toggleBanner }: BannerProps) {
  const { config: { webBanner } = {} } = usePageDataContext();

  const { sys, fields }: any = webBanner ?? {};

  switch (sys?.contentType?.sys?.id) {
    case 'variationContainer':
      // Do not lazy load
      fields.variations!.forEach((variation: IVariation) => {
        variation!.fields.pageBlock!.fields = {
          ...variation!.fields.pageBlock!.fields,
          toggleBanner
        } as any;
      });
      return <VariationContainer {...fields} sysId={sys?.id} />;

    case 'webBanner':
      return <WebBanner {...fields} toggleBanner={toggleBanner} />;

    default:
      return null;
  }
}
